/** Tiny stroke icons for table row actions (16px, currentColor). */

interface IconProps {
  size?: number;
}

function frame(size: number) {
  return {
    'aria-hidden': true as const,
    fill: 'none',
    height: size,
    viewBox: '0 0 16 16',
    width: size,
    stroke: 'currentColor',
    strokeWidth: 1.4,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  };
}

export function PlusIcon({ size = 14 }: IconProps) {
  return (
    <svg {...frame(size)}>
      <path d="M8 3v10M3 8h10" />
    </svg>
  );
}

export function EyeIcon({ size = 14 }: IconProps) {
  return (
    <svg {...frame(size)}>
      <path d="M1.5 8s2.4-4.2 6.5-4.2S14.5 8 14.5 8s-2.4 4.2-6.5 4.2S1.5 8 1.5 8Z" />
      <circle cx="8" cy="8" r="1.8" />
    </svg>
  );
}

export function PencilIcon({ size = 14 }: IconProps) {
  return (
    <svg {...frame(size)}>
      <path d="m9.8 3.2 3 3L5.5 13.5l-3.4.9.9-3.4 6.8-7.8Z" />
    </svg>
  );
}

export function TrashIcon({ size = 14 }: IconProps) {
  return (
    <svg {...frame(size)}>
      <path d="M2.5 4.5h11M6 4.5V3h4v1.5M4 4.5l.7 9h6.6l.7-9" />
    </svg>
  );
}

export function DownloadIcon({ size = 14 }: IconProps) {
  return (
    <svg {...frame(size)}>
      <path d="M8 2.5v8m0 0L4.8 7.3M8 10.5l3.2-3.2M3 13.5h10" />
    </svg>
  );
}
